import styled from 'styled-components';

export const Container = styled.div`
    background-color: #ffb1f9;
    padding: 10px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    span{
        text-transform: uppercase;
        font-weight: 600;
    }

    @media screen and (max-width: 900px){
        span{
            font-size: 12px;
        }
    }
`;
